import { gql } from '@apollo/client';

export const GET_ALL_FINANCE_RECORDS = gql`
  query getAllFinanceRecords(
    $from: String
    $to: String
    $year: String
    $month: String
    $spentBy: String
    $category: String
    $subCategory: String
    $purchaseDetails: String
    $invoice: String
    $quantity: String
    $amount: String
    $transactionMode: String
    $page: Int
    $pageSize: Int
  ) {
    getAllFinanceRecords(
      from: $from
      to: $to
      year: $year
      month: $month
      spentBy: $spentBy
      category: $category
      subCategory: $subCategory
      purchaseDetails: $purchaseDetails
      invoice: $invoice
      quantity: $quantity
      amount: $amount
      transactionMode: $transactionMode
      page: $page
      pageSize: $pageSize
    ) {
      records {
        id
        date
        category
        subCategory
        purchaseDetails
        invoice
        quantity
        amount
        spentBy
        status
        transactionMode
        remarks
        updateHistory {
          editedBy
          editedAt
          changes {
            field
            oldValue
            newValue
          }
        }
         attachments {
        id
        filename
        data
        userId
        emailId
        mimetype
        addDate
        updateDate
        status
        userName
        attachmetHistory{
        userId
       emailId
       userName
        replacedFile
       data
      filename
    mimetype
     deleteDate
    addDate
    updateDate
    status
        }
      }
      }
      totalCount
    }
  }
`;

export const REMOVE_ATTACHMENT_FINANCE = gql`
  mutation removeAttachmentFince($id: String!, $userId: String! ,$input:AttachemntsInputType! ) {
    removeAttachmentFince(id: $id, attachmentId: $userId ,input:$input ) {
       status
       message
}
  }
`;
export const UPDATE_ATTACHMENTS_FINANCE = gql`
mutation modifyAttachmentDetailsFinance($id: String, $input: AttachemntsInputType!) {
    modifyAttachmentDetailsFinance(attachmentid: $id, input: $input) {
      id
      filename
      data
      mimetype
      addDate
      updateDate
      status
    }
  }
`


export const ADD_FINANCE_RECORD = gql`
  mutation AddFinanceRecord(
    $date: String!
    $category: String!
    $subCategory: String
    $purchaseDetails: String
    $invoice: String
    $quantity: String
    $amount: String
    $spentBy: String
    $transactionMode: String
    $remarks: String
    $attachemnts: [AttachemntsInputType],
    $userName: String
  ) {
    addFinanceRecord(
      date: $date
      category: $category
      subCategory: $subCategory
      purchaseDetails: $purchaseDetails
      invoice: $invoice
      quantity: $quantity
      amount: $amount
      spentBy: $spentBy
      transactionMode: $transactionMode
      remarks: $remarks
      userName: $userName
      input:$attachemnts
    ) {
        id
        date
        category
        subCategory
        purchaseDetails
        invoice
        quantity
        amount
        spentBy
        status
        transactionMode
        remarks
        updateHistory {
          editedBy
          editedAt
          changes {
            field
            oldValue
            newValue
          }
        }
        attachments{
          userId
          data
          filename
          mimetype
          status
          addDate
          updateDate
        } 
    }
  }
`;

export const EDIT_FINANCE_RECORD = gql`
  mutation EditFinanceRecord(
    $id: ID!
    $date: String
    $category: String
    $subCategory: String
    $purchaseDetails: String
    $invoice: String
    $quantity: String
    $amount: String
    $spentBy: String
    $transactionMode: String
    $remarks: String
    $userName: String
    $task: String
    $attachemnts: [AttachemntsInputType]
  ) {
    editFinanceRecord(
      id: $id
      date: $date
      category: $category
      subCategory: $subCategory
      purchaseDetails: $purchaseDetails
      invoice: $invoice
      quantity: $quantity
      amount: $amount
      spentBy: $spentBy
      transactionMode: $transactionMode
      remarks: $remarks
      userName: $userName
      task: $task
      input:$attachemnts
    ) {
        id
        date
        category
        subCategory
        purchaseDetails
        invoice
        quantity
        amount
        spentBy
        status
        transactionMode
        remarks
        updateHistory {
          editedBy
          editedAt
          changes {
            field
            oldValue
            newValue
          }
        }
        attachments{
          userId
          data
          filename
          mimetype
          status
          addDate
          updateDate
        } 
    }
  }
`;

export const SOFT_DELETE_FINANCE_RECORD = gql`
  mutation DeleteFinanceRecord($id: ID!, $userName: String!, $editedAt: String!) {
    deleteFinanceRecord(id: $id, userName: $userName, editedAt: $editedAt)
  }
`;
